/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Link, Text, View } from '@react-pdf/renderer';
import { FirstCallInfo as IFirstCallInfo } from '../../../models/pro.model';
import styles from '../pro-report-pdf-styles';

interface FirstCallInfoProps {
  firstCallInfo: IFirstCallInfo | null | undefined;
}

function FirstCallInfo({ firstCallInfo }: FirstCallInfoProps) {
  if (firstCallInfo)
    return (
      <View>
        <View wrap={false} style={styles.table}>
          <View style={styles.tableRow}>
            <Text style={styles.tableHeaderFullWidth}>First Call contact</Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={styles.tableSubHeaderFullWidth}>
              <Text style={{ fontWeight: 700 }}>Company:</Text>{' '}
              {firstCallInfo.company ?? 'N/A'}
            </Text>
          </View>
          <View style={styles.tableRow}>
            <Text
              style={{
                ...styles.tableCellReducedWidth,
                borderRightWidth: 0,
                width: '50%',
              }}
            >
              <Text style={{ fontWeight: 700 }}>Email:</Text>{' '}
              {firstCallInfo.email ? (
                <Link
                  src={`mailto:${firstCallInfo.email}`}
                  style={styles.mailToLink}
                >
                  {firstCallInfo.email}
                </Link>
              ) : (
                'N/A'
              )}
            </Text>
            <Text style={styles.tableCellFullWidth}>
              <Text style={{ fontWeight: 700 }}>Telephone:</Text>{' '}
              {firstCallInfo.telephone ?? 'N/A'}
            </Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={styles.tableCellFullWidth}>
              <Text style={{ fontWeight: 700 }}>Advice:</Text> For matters
              involving the disembarkation of crew for medical treatment in the
              USA/Brazil.
            </Text>
          </View>
        </View>
        <View style={styles.hr} />
      </View>
    );
  return null;
}

export default FirstCallInfo;
